import React, { useContext } from 'react';
import Slider from 'react-slick';
import TemplateDataContext from '../../Contexts/TemplateData.context';
import Template from '../Template/Template';
import { GoChevronLeft } from "react-icons/go";
import { GoChevronRight } from "react-icons/go";


type Props = {};

const SliderComponent = (props: Props) => {
  const { state } = useContext(TemplateDataContext);
  const { templateKeys, selectedState } = state;

  // Custom Next Arrow Component
  const CustomNextArrow = (props: any) => {
    const { onClick } = props;
    return (
      <button className="slick-next-button" onClick={onClick}>
        <GoChevronRight size={20}/>

      </button>
    );
  };

  // Custom Previous Arrow Component
  const CustomPrevArrow = (props: any) => {
    const { onClick } = props;
    return (
      <button className="slick-prev-button" onClick={onClick}>
                <GoChevronLeft size={20}/>

      </button>
    );
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className={selectedState !== '' ? 'row state-specific-template' : 'row'}>
      <Slider {...settings}>
        {templateKeys.length > 0 &&
          templateKeys.map((templateKey, index) => (
            <div key={`${templateKey}${index}`} className={templateKeys.length === 1 ? 'template-width' : ''}>
              <Template isInnerPage={false} templateKey={templateKey} index={index} />
            </div>
          ))}
      </Slider>
                  {/* {window.innerWidth <991 && (
                <div className="text-center">
                    <button className="btn btn-primary primary-button-select-template">Select Template</button>
                </div>
            )} */}
    </div>
  );
};

export default SliderComponent;
